import axios, { AxiosResponse } from 'axios'
import { setApiUrl } from 'api/helpers'
import { RESOURCE_ENDPOINT } from './config'
import { TGetCsrfTokenResponse } from "./types";

export const getCsrfToken = async (): Promise<AxiosResponse<TGetCsrfTokenResponse>> => {
  const url = setApiUrl(RESOURCE_ENDPOINT)
  return axios.get(url)
}
